import script from "./LeadShowContent.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadShowContent.vue?vue&type=script&setup=true&lang=js"

import "./LeadShowContent.vue?vue&type=style&index=0&id=60185efa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60185efa"]])

export default __exports__